import React from "react";
import {Link} from "react-router-dom";

function handleInternalClick() {
    window.scrollTo({
        top: 0,
        left: 0,
        behavior: "auto",
    });
}

export default function PlatformNewsActionLink({
    action,
    className,
}) {
    if (!action) {
        return null;
    }

    const content = (
        <>
            {action.label}
            <span aria-hidden="true">→</span>
        </>
    );

    if (action.path) {
        return (
            <Link
                className={className}
                to={action.path}
                onClick={handleInternalClick}
            >
                {content}
            </Link>
        );
    }

    return (
        <a
            className={className}
            href={action.href}
            target={action.external ? "_blank" : undefined}
            rel={action.external ? "noreferrer" : undefined}
        >
            {content}
        </a>
    );
}
